// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { SystemListState } from "@steiner/App/Store/Reducers";
import { isSchneiderProduct } from "@steiner/App/Store/Selectors/SystemListSelector";
import { getCategoryLevels } from "@steiner/XDL/Utilities";

export const CHECKOUT_STEPS = {
    CART: 0,
    ADDRESS: 1,
    SHIPPING: 2,
    PAYMENT: 3,
    REVIEW: 4,
};

const getDataLayer = () => {
    return (window as any).dataLayer || [];
};

export { getDataLayer };

/* eslint-disable */
(function (window) {
    (window as any)._GaCheckoutFunnel = (
        step: number,
        cart: CartModel,
        currency?: string,
        affiliation?: string,
        // discount?: number,
        includeBrand?: boolean,
        includeCategory?: boolean,
        xSystemList?: SystemListState,
    ) => {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            ...(step === CHECKOUT_STEPS.ADDRESS && {
                event: "begin_checkout",
            }),
            ...(step === CHECKOUT_STEPS.SHIPPING && {
                event: "add_shipping_info",
                shipping_tier: cart.carrier?.description || "",
            }),
            ...(step === CHECKOUT_STEPS.PAYMENT && {
                event: "add_payment_info",
                payment_type: cart.paymentMethod?.description || "",
            }),
            ecommerce: {
                currency,
                value: cart.orderGrandTotal,
                coupon: cart.promotionCode,
                shipping_tier: cart.shipVia?.description,
                items: cart?.cartLines?.map((cartLine, idx) => ({
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    ...(step === CHECKOUT_STEPS.ADDRESS &&
                        xSystemList && {
                            isSchneider: isSchneiderProduct(xSystemList, cartLine.brand?.name),
                        }),
                    item_brand: includeBrand ? cartLine.brand?.name || "" : undefined,
                    ...(includeCategory ? getCategoryLevels(cartLine.properties) : {}),
                    item_list_id: includeCategory ? cartLine.properties?.["categoryId"] || "" : undefined,
                    discount: cartLine.pricing
                        ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                            ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                            : 0
                        : 0,
                    coupon: cart.promotionCode,
                    affiliation,
                    index: idx,
                })),
            },

            value: cart.orderSubTotal,
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(googleAnalyticsData);

        if (step === CHECKOUT_STEPS.ADDRESS) {
            const schneiderItems = googleAnalyticsData.ecommerce.items?.filter(item => item.isSchneider);
            if (schneiderItems?.length) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    ...googleAnalyticsData,
                    event: "se_begin_checkout",
                    ecommerce: {
                        ...googleAnalyticsData.ecommerce,
                        items: schneiderItems,
                    },
                });
            }
        }
    };
})(typeof window != "undefined" ? window : {});
/* eslint-enable */
